@if (getMovementDuration(); as movementDuration) {
  <span title="Movement duration" class="d-none d-lg-inline me-3 text-muted">
    <span class="far fa-fw fa-clock me-1"></span>{{ movementDuration }}
  </span>
}
